module.exports = __webpack_public_path__ + "videos/6.3652370.mp4";